import * as api from "@/api/podcasts.api"
import { notificationError } from "@/common/helpers/notifications.helper"

export const resetPodcasts = ({ commit }) => {
  commit("setPodcasts", [])
}

export const resetPodcast = ({ commit }) => {
  commit("resetPodcast")
  commit("Episode/reset", [], { root: true })
}

export const getPodcasts = async ({ commit }, accountKey) => {
  try {
    const podcasts = await api.getPodcasts(accountKey)
    commit("setPodcasts", podcasts)
    return podcasts
  } catch (e) {
    console.error(e)
    await notificationError("Unable to load the podcasts. Please try again.", "Failed to load podcasts")
    throw e
  }
}

export const getPodcast = async ({ commit }, payload) => {
  try {
    const podcast = await api.getPodcast(payload)
    commit("setPodcast", podcast)
    return podcast
  } catch (e) {
    console.error(e)
    await notificationError("Unable to load the podcast. Please try again.", "Failed to load podcast")
    throw e
  }
}

export const updatePodcast = async ({ commit }, data) => {
  try {
    const podcast = await api.updatePodcast(data)
    commit("setPodcast", podcast)
    return podcast
  } catch (e) {
    console.error(e)
    await notificationError("Unable to save changes. Please try again.", "Failed to update podcast")
    throw e
  }
}
